import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { MovableCardWrapper } from '../../styles/Base'
import diamond from "../../../../../../../images/grafix-icon/diamond.svg";
import EllipsisTooltip from './../../../../../../common/EllipsisTooltip';
import { Icon, Popup, Grid, List } from "semantic-ui-react";
import PlaybookActivityCard from '../../../cards/PlaybookActivityCard'
class Card extends Component {
  removeCard = e => {
    const { id, laneId, removeCard, onDelete } = this.props
    removeCard(laneId, id)
    onDelete(id, laneId)
    e.stopPropagation()
  }

  renderBody = () => {
    if (this.props.customCardLayout) {
      const { customCard, ...otherProps } = this.props
      return React.cloneElement(customCard, { ...otherProps })
    } else {
      const { title } = this.props
      return (
        <span title="">
          <EllipsisTooltip name={title} line={2} />
        </span>
      )
    }
  }
  getMapping(id) {
    if (this.props.communities)
      for (let i = 0; i < this.props.communities.length; i++) {
        let community = this.props.communities[i];
        if (id === community._id) {
          return community.name;
        }
        if (community.communities) {
          for (let j = 0; j < community.communities.length; j++) {
            let subCommunity = community.communities[j];
            if (id === subCommunity._id) {
              return community.name + " > " + subCommunity.name;
            }
          }
        }

      }
  }
  removeActivity = e => {
    const { id, laneId, removeCard, onDelete } = this.props
    removeCard(laneId, id)

  }
  render() {
    const { id, cardStyle, editable, hideCardDeleteIcon, customCardLayout, dragStyle, isMilestone, duration, selectedActivity, _id, ...otherProps } = this.props
    const style = customCardLayout ? { ...cardStyle, padding: 0 } : cardStyle

    return (
      <MovableCardWrapper
        key={id}
        data-id={id}
        style={{
          ...style,
          ...dragStyle
        }}
        title=""
        {...otherProps}>
        <PlaybookActivityCard
          type="activity"
          page="assign"
          selectedPracticeLibrary={this.props.selectedPracticeLibrary}
          activityData={this.props.cardDetail}
          selectedActivity={this.props.selectedActivity}
          removeActivity={this.removeActivity}
          communities={this.props.communities}
          _id={_id}
          user={this.props.user}
          currentOrganization={this.props.currentOrganization} 
        />

      </MovableCardWrapper>
    )
  }
}

Card.defaultProps = {
  cardStyle: {},
  customCardLayout: false,
  onDelete: () => { },
  editable: false,
  dragStyle: {}
}

Card.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  index: PropTypes.number,
  description: PropTypes.string,
  label: PropTypes.string,
  tags: PropTypes.array,
  laneId: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  removeCard: PropTypes.func,
  onDelete: PropTypes.func,
  metadata: PropTypes.object,
  cardStyle: PropTypes.object,
  dragStyle: PropTypes.object,
  tagStyle: PropTypes.object,
  customCardLayout: PropTypes.bool,
  customCard: PropTypes.node,
  editable: PropTypes.bool
}

export default Card
